module.exports = __webpack_public_path__ + "static/media/chicken_chowmin.fb671780.jpeg";